import React, { useEffect } from 'react'
import '../UserRegistrationScene/index.scss'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { NavLink } from 'react-router'

const UserRegistrationCompleteScene = () => {
    useEffect(() => {
        analyticsSendPage('user_registration_complete')
    }, [])

    return (
        <>
            <title>User registration</title>
            <main className="user-registration-scene">
                <div className="global-container after-reg">
                    <h2>Your account verification is in progress!</h2>

                    <p>
                        The MLC uses identity verification before a user is registered to comply with Know Your Customer
                        (KYC) regulations. KYC is required to establish the legitimacy of a user&apos;s identity and
                        helps to prevent the creation and use of fraudulent accounts.
                    </p>

                    <NavLink to="/">Go to Portal</NavLink>
                </div>
            </main>
        </>
    )
}

export default UserRegistrationCompleteScene
